<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-text>
        <h3 class="headline mb-0">{{ $t("application.category") }}</h3>
        <v-form ref="form">
          <v-select :items="allCategories" v-model="selectedCategory" />
          <v-text-field v-model="order" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'CompetitionCategory',
    data: () => ({
      dialog: false,
			allCategories: [],
			selectedCategory: null,
			order: 0
    }),
    computed: {
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      }
		},
		props: {
			reload: Function
		},
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog
    },
    methods: {
      show: function(){
        this.dialog = true;
      },
      save: function(){
				var competitionId = this.$store.getters.competitionId;
				var cat = this.selectedCategory;
				var rel = this.reload;
				var d = this.dialog;
				fccapi.post(`competitions/${competitionId}/categories/${cat}`, [this.order]).then(d => {
					this.dialog = false;
					rel();
				}).catch(e => {
					console.log(e)
				})
      }
    },
    mounted: function(){
      fccapi.get('categories').then(d => {
				this.allCategories = d.data;
			})
    }
  }
</script>